import type { UseMutationResult } from "@tanstack/react-query"

import { useSolarConcertStatusCommand } from "./solar-concert-application-cache"
import type {
  SolarConcertApplicationStatusDto,
  SubmitSolarConcertApplicationDto,
} from "../dto/solar-concert.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Submit the in-person Concert application for the current Quote. The server
 * owns the financed amount and idempotency; a refused attempt may still have
 * persisted a failed or uncertain application, so errors refetch status.
 */
export default function useSubmitSolarConcertApplication(): UseMutationResult<
  SolarConcertApplicationStatusDto,
  unknown,
  { proposalId: string; body: SubmitSolarConcertApplicationDto }
> {
  return useSolarConcertStatusCommand(({ proposalId, body }) =>
    solarProposalService.submitConcertApplication(proposalId, body),
  )
}
